var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6333",
    "data-name": "Rectangle 6333",
    width: 40,
    height: 39.323,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34943",
    "data-name": "Group 34943",
    transform: "translate(-4188 -5405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4188 5405)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34881",
    "data-name": "Group 34881",
    transform: "translate(4205 5422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34880",
    "data-name": "Group 34880",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24400",
    "data-name": "Path 24400",
    d: "M0,42.331c.082-.111.171-.218.244-.335q5.5-8.732,11-17.466l.062-.1c.435-.683.9-.693,1.387-.03q.425.583.849,1.169l2.45,3.369c.1-.154.18-.275.256-.4q3.829-6.325,7.656-12.651a2.959,2.959,0,0,1,.255-.392.645.645,0,0,1,1.018.01,3.18,3.18,0,0,1,.283.466Q32.607,28.96,39.749,41.948a2.927,2.927,0,0,1,.206.419.625.625,0,0,1-.421.832,2.018,2.018,0,0,1-.54.051q-19,0-38,.008A1.02,1.02,0,0,1,0,42.8v-.469M10.227,28.649,1.888,41.9c.143.012.216.024.289.024q5.663,0,11.326-.009a1.006,1.006,0,0,0,.554-.22q5.281-4.02,10.549-8.057c.652-.5.732-.5,1.417-.079l11.048,6.84c.11.068.221.131.4.236a2.085,2.085,0,0,0-.076-.2q-4.52-8.22-9.045-16.438a.743.743,0,0,0-.287-.3c-1.008-.515-2.019-1.022-3.038-1.511a.453.453,0,0,0-.39.065,8.369,8.369,0,0,0-.642.626c-.463.459-.692.483-1.226.13-.377-.249-.752-.5-1.144-.761-1.6,2.637-3.17,5.238-4.748,7.846l2.306,2.733-1.037.87-3.6-4.375-.508.756c-.388.577-.692.642-1.265.263-.835-.551-1.666-1.107-2.539-1.687M16,41.891H36.957l-8.646-5.348c-.791.793-1.561,1.568-2.334,2.339-.409.408-.638.46-1.142.185a6.424,6.424,0,0,0-2.2-.746c-.411-.059-.813-.187-1.224-.232a.917.917,0,0,0-.6.131c-1.057.781-2.094,1.588-3.137,2.385L16,41.891M24.64,17.25l-2.327,3.844.977.651c.256-.278.5-.562.768-.829a.748.748,0,0,1,1.077-.181c.513.252,1.022.51,1.534.763.1.052.213.095.409.181L24.64,17.25m2.506,18.569c-.565-.349-1.091-.68-1.626-1a.3.3,0,0,0-.27.007c-.9.677-1.795,1.364-2.7,2.054.047.037.063.061.084.065a7.385,7.385,0,0,1,2.44.751.259.259,0,0,0,.237-.047c.608-.6,1.209-1.206,1.833-1.833m-14-6.83c.153-.226.27-.43.417-.611a.371.371,0,0,0-.017-.542c-.321-.408-.613-.838-.92-1.258-.186-.254-.377-.506-.592-.8L10.942,27.52l2.206,1.469",
    transform: "translate(0 -3.936)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24401",
    "data-name": "Path 24401",
    d: "M45.661,23.952c-.7,0-1.406,0-2.109,0a2.051,2.051,0,0,1-2.15-1.508A2.013,2.013,0,0,1,42.566,20.1a.564.564,0,0,0,.224-.284,2.657,2.657,0,0,1,4.252-1.241.539.539,0,0,0,.375.1,2.668,2.668,0,1,1,.469,5.271c-.741.016-1.484,0-2.226,0m.046-1.335v-.039c.844,0,1.692.056,2.529-.016a1.261,1.261,0,0,0,1.048-1.613,1.3,1.3,0,0,0-1.739-.906c-.69.252-.712.246-1.237-.312a1.315,1.315,0,0,0-2.28.7c-.1.651-.159.718-.8.87a.62.62,0,0,0-.54.657.608.608,0,0,0,.567.633,2.327,2.327,0,0,0,.387.024c.689,0,1.377,0,2.066,0",
    transform: "translate(-10.665 -4.632)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24402",
    "data-name": "Path 24402",
    d: "M12.979,5.369a4.042,4.042,0,0,1,4.012,3.99,4,4,0,0,1-8.008.014,4.041,4.041,0,0,1,4-4m0,1.34a2.663,2.663,0,0,0,0,5.326,2.663,2.663,0,1,0,0-5.326",
    transform: "translate(-2.318 -1.385)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24403",
    "data-name": "Path 24403",
    d: "M18.913,16.123l.831-.811,1.848,1.836-.868.777-1.811-1.8",
    transform: "translate(-4.88 -3.951)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6329",
    "data-name": "Rectangle 6329",
    width: 1.295,
    height: 2.61,
    transform: "translate(10.017)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6330",
    "data-name": "Rectangle 6330",
    width: 2.624,
    height: 1.274,
    transform: "translate(2.687 7.342)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6331",
    "data-name": "Rectangle 6331",
    width: 2.624,
    height: 1.277,
    transform: "translate(16.03 7.34)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6332",
    "data-name": "Rectangle 6332",
    width: 1.281,
    height: 2.616,
    transform: "translate(10.029 13.341)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24404",
    "data-name": "Path 24404",
    d: "M6.223,3.431,7.036,2.6,8.884,4.448l-.849.8L6.223,3.431",
    transform: "translate(-1.606 -0.672)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24405",
    "data-name": "Path 24405",
    d: "M19.788,5.335l-.844-.87L20.75,2.657l.855.861L19.788,5.335",
    transform: "translate(-4.888 -0.686)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24406",
    "data-name": "Path 24406",
    d: "M8.052,15.309l.855.847L7.068,17.987l-.861-.841,1.845-1.837",
    transform: "translate(-1.602 -3.95)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.dc0eaeb37b045c0b871f011b2278fe40.svg";
export { ForwardRef as ReactComponent };